import { useEffect } from 'react';
import { useContent } from '../redux/reducer/content';

export const useBodyClassByState = () => {
  const { state, previousStates } = useContent();

  useEffect(() => {
    document.body.classList.remove(`_${previousStates[previousStates.length - 1]}`);
    document.body.classList.add(`_${state}`);
  }, [state]);
};
